var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"750","value":_vm.dialog},on:{"click:outside":_vm.close}},[_c('v-card',{staticClass:"align-center d-flex flex-column py-10 px-7"},[_c('CloseDialogButton',{attrs:{"close":_vm.close}}),_c('SupportContent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }